import React from 'react';
import PropTypes from 'prop-types';
import { cx } from '@linaria/core';
import {
  labelsContainerStyles,
  labelsHoverStyles,
  labelStyles,
  descriptionStyles,
  labelVariationStyles,
  descriptionVariationStyles,
  labelThemeStyles,
  descriptionThemeStyles,
  descriptionActionHover,
} from './styles.js';

const Labels = ({
  label,
  description,
  labelVariation = 'bold',
  descriptionVariation = 'bold',
  showFullDescription = false,
  showTitle = false,
  title,
  theme = 'light',
  className,
  externalLabelsClassName,
  externalDescriptionClassName,
  onDescriptionLabelClick,
  style = {},
}) => {
  const labelClassname = cx(
    labelStyles,
    labelVariationStyles[labelVariation],
    labelThemeStyles[theme],
    externalLabelsClassName,
  );
  const descriptionClassname = cx(
    !showFullDescription && descriptionStyles,
    descriptionVariationStyles[descriptionVariation],
    descriptionThemeStyles[theme],
    externalDescriptionClassName,
    typeof onDescriptionLabelClick === 'function' && descriptionActionHover,
  );
  const containerClassName = cx(labelsContainerStyles, labelsHoverStyles, className);

  return (
    <span className={containerClassName} style={style}>
      {label && <span className={labelClassname} title={showTitle ? (title || label) : ''}>{label}</span>}
      {description && (
        <span
          className={descriptionClassname}
          title={showTitle ? description : ''}
          onClick={onDescriptionLabelClick}
        >
          {description}
        </span>
      )}
    </span>
  );
};

Labels.propTypes = {
  label: PropTypes.node,
  description: PropTypes.node,
  labelVariation: PropTypes.oneOf(['roman', 'bold']),
  descriptionVariation: PropTypes.oneOf(['roman', 'bold', 'romanLight']),
  className: PropTypes.string,
};

export default Labels;
